export enum EiFieldRecencyAction {

    PREFER_IMPORT,
    PREFER_SYSTEM,
    MANUAL_DECISION,
    USE_TIMESTAMP,
    USE_LOGIC,
    REJECT,
}
